export const SET_SCHEDULE_EVENTS_LOADED = "SET_SCHEDULE_EVENTS_LOADED";

export const setScheduleEventsLoaded = (scheduleEventsLoaded: boolean) => {
  return {
    scheduleEventsLoaded,
    type: SET_SCHEDULE_EVENTS_LOADED
  };
};
